import React from "react";

import { DynamicForm } from "src/components/Form";

import { contactFields } from "./fields";

const fields = options => ({ t }) => [
  {
    type: "section",
    title: t("forms.shortContactTitle", {
      defaultValue: "Short Contact Title",
    }),
    fields: [
      ...contactFields({
        t,
        includeAccountNumber: false,
        phoneRequired: true,
        includeEmail: false,
      }),

      {
        key: "bestAppointmentTime",
        label: t("forms.contact.bestContactTimeLabel", {
          defaultValue: "When is the best time for us to contact you?",
        }),
        type: "dropdown",
        placeholder: t("forms.contact.bestContactTimePlaceholder", {
          defaultValue: "Choose One",
        }),
        inputProps: {
          options,
        },
        required: true,
      },
      {
        key: "isMember",
        label: t("forms.contact.isMember", {
          defaultValue: "Are you currently a member of Financial Center?",
        }),
        type: "optionButtons",
        inputProps: {
          options: [
            {
              value: "Yes",
              label: t("forms.feedback.yes"),
            },
            {
              value: "No",
              label: t("forms.feedback.no"),
            },
          ],
        },
      },
    ],
  },
];

const ShortContactForm = ({ moduleKey, options }) => (
  <DynamicForm
    formKey={options.formKey || moduleKey}
    fields={fields(options.options)}
    defaultSuccessMessageKey="forms.defaultSuccessMessage"
  />
);

export default ShortContactForm;



// WEBPACK FOOTER //
// ./src/components/Content/forms/ShortContact.js